/* eslint-disable */
export const CopyUrlToClipboard = () => {
  const url = window.location.href;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    console.log('pass check');
    navigator.clipboard
      .writeText(url)
      .then(() => {
        return true;
      })
      .catch((err) => {
        return false;
      });
  }
  return true;
};
